import Landing from "./components/Landing/Landing";
import About from "./components/About/About";

function App() {
  return (
    <div style={{fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif", backgroundColor: '#1c1714'}}>
      <Landing />
      <About />
    </div>
  );
}

export default App;
